// Component: Templates Search

class TemplateSearch {
  constructor() {
    this.searchComponent = $('.templates-search-component')
    this.modal = $('.js_results-modal', this.searchComponent)
    this.searchBar = $('.js_templates-search', this.searchComponent)
    this.glassIcon = $(
      '.js_templates-search__icon--glass',
      this.searchComponent,
    )
    this.xButtonIcon = $(
      '.js_templates-search__icon--x-button',
      this.searchComponent,
    )
    this.templateList = $('.templates-search__results-list-link')

    this.attachEvent()
  }

  attachEvent() {
    // Trigger visible search dropdown
    this.searchBar.focusin((event) => {
      this.searchComponent.addClass('is-active')
    })
    this.searchBar.focusout((e) => {
      // Leave via results list
      setTimeout(() => {
        this.searchComponent.removeClass('is-active')
      }, 200)
    })

    // Listen for changes and filter results
    this.searchBar.on('input', () => {
      // When the user starts typing
      if (this.searchBar.val().length > 0) {
        // Hide all templates
        this.templateList.addClass('is-nonmatch')
        let searchTerm = this.searchBar
          .val()
          .trim()
          .toLowerCase()

        // Check for matches
        this.templateList.each((index, element) => {
          //If search matches
          // if ($(element).data("template-name").trim().toLowerCase().includes(searchTerm)) {
          if (
            element.innerText
              .trim()
              .toLowerCase()
              .includes(searchTerm)
          ) {
            // Show template as a match
            $(element).removeClass('is-nonmatch')
          }
        })

        // Clear search terms
        this.xButtonIcon.click((e) => {
          this.xButtonIcon.removeClass('is-active')
          this.searchBar.val('')
        })

        // Make x button visible when at least one character is present
        if (!this.xButtonIcon.hasClass('is-active')) {
          this.xButtonIcon.addClass('is-active')
        }

        // Highlight result if there's only one
        this.matches = $('.js_results-list-link').not('.is-nonmatch')
        if (this.matches.length === 1) {
          this.matches.addClass('-highlight')
        } else {
          this.matches.removeClass('-highlight')
        }
      } else if (this.searchBar.val().length === 1) {
        this.templateList.removeClass('is-nonmatch')
      } else {
        this.xButtonIcon.removeClass('is-active')
        this.templateList.removeClass('is-nonmatch')
      }
    })

    // Listen for keypress
    this.searchBar.keypress(function(e) {
      // Check if it's "enter" key
      this.matches = $('.js_results-list-link').not('.is-nonmatch')
      if (e.which === 13) {
        // Only go to result when there's one result
        if (this.matches.length === 1) {
          window.location = this.matches.attr('href')
        }
      }
    })
  }
}

export default TemplateSearch
